import { useEffect } from "react";
import { AuthService } from "../auth/AuthService";
import { teacherOidcConfig } from "../auth/oidcConfig";
import { useNavigate } from "react-router-dom";

const TeacherCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const authService = new AuthService(teacherOidcConfig);
        const user = await authService.handleSigninCallback();
        
        if (user) {
          
          // 導向預定目的地 - 改為導向書籍預覽頁面
          const intendedPath = sessionStorage.getItem('intended_path') || '/book-preview';
          sessionStorage.removeItem('intended_path');
          navigate(intendedPath, { replace: true });
        } else {
          console.error("教師認證失敗：未獲取到用戶信息");
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error("教師 OIDC 回調處理失敗:", error);
        navigate('/', { replace: true });
      }
    };

    // 延遲執行，確保 React 完全載入
    const timer = setTimeout(handleCallback, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">正在處理教師登入...</p>
      </div>
    </div>
  );
};

export default TeacherCallback;